<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="/">
        <img class="navbar-brand-full" :src="custom.image || 'img/F1-uwss.png'" width="89" height="25">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
        <b-navbar-nav class="d-md-down-none">
          <!-- <b-nav-item class="px-3" to="/dashboard"><b style="color:black">Dashboard</b></b-nav-item> -->
          <b-nav-item class="px-3" to="/management/group"><b style="color:#3D63BA">Group</b><b style="color:black; font-size:10px"></b></b-nav-item>
          <b-nav-item class="px-3" to="/management/billing"><b style="color:#3D63BA">Billing</b><b style="color:black; font-size:10px"></b></b-nav-item>
          <b-nav-item v-if="auth.profile.permissions != 'billing'" class="px-3" to="/board"><b style="color:black">Board</b><b-nav-item class="px-3" to="/board"><b style="color:black">Service Invoice</b></b-nav-item></b-nav-item>
          <b-nav-item class="px-3" @click="menual()"><b style="color:black">Manual</b></b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item to="/management/profile" style="margin-right: 25px;">
          <i class="fa fa-user md-5"></i>
          {{ auth.profile.username }}
        </b-nav-item>

        <b-nav-item @click="toggle" style="margin-right: 25px;">
          <i class="fa fa-clock-o" :class="{ 'text-secondary' : pause }" title="toggle auto logout"></i>
          <b-badge v-if="stale" pill :variant="pause ? 'secondary' : 'success'" >{{stale}}</b-badge>
        </b-nav-item>
        <b-nav-item @click="logout()" style="margin-right: 30px;">
          <i class="fa fa-sign-out" title="logout" @click="logout()"></i>
          <b-badge variant="white">logout</b-badge>
        </b-nav-item>
      </b-navbar-nav>

    </AppHeader>
    <div class="app-body pull-right" >
      <AppSidebar fixed ref="_list">
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"> </SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>

      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <TheFooter>
      <div>
        <div v-if="is_custom">
          -
        </div>
        <div v-else>
          <a href="http://www.f1security.co.kr">F1Security Inc.</a>
          <span>234, Beotkkot-ro, Geumcheon-gu, Seoul, Republic of Korea</span>
        </div>
      </div>
      <div class="ml-auto">
        <span>Copyright 2019. F1Security Inc. All right reserved.</span>
      </div>
    </TheFooter>
  </div>
</template>


<script>
// import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb } from '../components/'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import { auth, idle, signalr, Custom } from '@/service';
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import * as _ from 'lodash'
import config from '@/config'

let partner =  [

  { name: 'Dashboard', title : true , permissons: ['owner', 'manager' ]},
  { name: 'Dashboard', url: '/dashboard', icon: 'cui-dashboard ', permissons: ['owner', 'manager' ]},
  { name: 'Partner', title : true , permissons: ['owner', 'manager', 'billing' ]},
  { name: 'Profile', url: '/management/profile', icon: 'icon-lock', permissons: ['owner', 'manager', 'billing' ]},
  { name: 'My Invoice', url: '/management/invoice_partner', icon: 'icon-lock', permissons: ['owner', 'manager', 'billing' ]},
  { name: 'Management', title : true , permissons: ['owner', 'manager', 'billing' ]},
  // { name: 'User', url: '/management/user', icon: 'icon-people', permissons: ['owner', 'manager' ]},
  { name: 'Plans', url: '/management/plan', icon: 'icon-lock', permissons: ['owner', 'billing' ]},
  { name: 'Group', url: '/management/group', icon: 'icon-folder' , permissons: ['owner', 'manager', 'billing' ]},
  { name: 'Invoice', url: '/management/invoice_group', icon: 'icon-lock', permissons: ['owner', 'billing' ]},
  { name: 'Credit', url: '/management/credit', icon: 'icon-lock', permissons: ['owner', 'billing' ]},
  { name: 'Signout', url: '/management/signout', icon: 'icon-people', permissons: ['owner', 'manager' ]},

  { name: 'Board', title : true , permissons: ['owner', 'manager' ]},
  // { name: 'Main', url: '/board/main', icon: 'cui-dashboard' , permissons: ['owner', 'manager' ]},
  { name: 'Notice', url: '/board/notice', icon: 'icon-bell' , permissons: ['owner', 'manager' ]},
  { name: 'FAQ', url: '/board/faq', icon: 'icon-bulb' , permissons: ['owner', 'manager' ]},
  { name: 'Q & A', url: '/board/qna', icon: 'icon-question' , permissons: ['owner', 'manager' ]},

  { name: 'Log', title : true , permissons: ['owner', 'manager', 'billing' ]},
  { name: 'Login Log', url: '/log/login', icon: 'icon-layers' , permissons: ['owner', 'manager', 'billing' ]},
  { name: 'Action Log', url: '/log/action', icon: 'icon-layers' , permissons: ['owner', 'manager', 'billing' ]},
  // { name: 'Install Log', url: '/log/install', icon: 'icon-layers' , permissons: ['owner', 'manager', 'billing' ]},
  // { name: 'System', url: '/log/system', icon: 'icon-layers' , permissons: ['owner', 'manager' ]},
]

// let check_permit = vs => _.filter(vs, v => {
//   if(!auth.has_level(v.level)) { return undefined; }
//   if(_.isArray(v.children)) { v.children = check_permit(v.children); }
//   return v;
// });

export default {
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  // data: () => ({ nav: check_permit(links), pause: false, stale: undefined, stale_check : undefined }),
  data: () => {
    return {
      custom : Custom.custom_default,
      auth,
      // nav: partner,
      base_href : `${location.protocol}//${location.host}`,
      b : undefined,
      pause: false,
      // location : 'wmds',
      service : '',
      stale: undefined,
      stale_check : undefined,
    }
  },
  computed: {
    is_custom() {
      return this.custom.slogan && this.custom.slogan.toUpperCase().indexOf('F1-UWSS') < 0
    },
    name () { return this.$route.name },
    list () { return this.$route.matched },
    nav() { return _.filter(partner, r => _.indexOf(r.permissons, auth.profile.permissions) > -1) }
  },
  methods: {
    menual() { return window.open(`https://${location.hostname == 'localhost' ? 'api.f1secaas.net' : location.host.replace(/^[^\\.]*\./, 'api.')}/downloads/manual/${config.manual}`) },
    toggle() { this.pause = !this.pause; this.pause ? idle.pause() : idle.resume(); },
    logout() { auth.logout(); this.$router.push('/auth/login') },
  },
  created: function() {
    // Api.Partner_Call('user.signup','list', '').then((rs) => { this.sign = rs;}).catch(e => this.$toastr.e(e.data ? e.data.message : e.statusText));
    console.log('[vue] private container', 'created');
    this.custom = Custom.setting();

    idle.start(this.logout, 10).keepalive(auth.refresh, 300);
    signalr.start('ws')
      .on('msg', m => this.$toastr.s(m.body ? m.body : m, 'Message'))
      .on('emsg', m => this.$toastr.w(m, 'Message'))
      .on('err', m => console.error(m))
      .on('error', m => console.error(m))
      // .on('wmds', m => signalr.publish('wmds', m))
      // .on('wsfinder', m => signalr.publish('wsfinder', m))
      // .on('webcastle', m => signalr.publish('webcastle', m));
    this.stale_check = setInterval(() => {
      if(idle.p) { return this.stale = '∞'; }
      let ts = parseInt((idle.stale - new Date().getTime()) / 1000);
      if(ts > 300) { return this.stale = '+5:00'; } // 5분 이내는 신경쓰지 않음.
      let m = (parseInt(ts / 60)).toString();
      let s = (parseInt(ts % 60) + 100).toString().substr(1,2);
      return this.stale = `${m}:${s}`;
    }, 1000);
  },
  destroyed: function() {
    console.log('[vue] private container', 'destroyed');
    signalr.stop();
    idle.stop();
    clearInterval(this.stale_check);
  },
  mounted: function() { console.log('[vue] private container', 'mounted'); },
}
</script>
